import React, { Component } from 'react'

import { Form } from 'formsy-semantic-ui-react';
import { Button, Popup, Icon, Radio } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import "../Toolbar.css";
import capitalizeWord from '../../../../../helpers/capitalizeWord';

let PlaybookArr = [

    { key: 'subCategory', value: 'subCategory', order: -1, text: "Sub Category" },
    { key: 'status', value: 'status', order: -1, text: "Status" },
    { key: 'scope', value: 'scope', order: -1, text: "Library" },
    { key: 'tags', value: 'tags', order: -1, text: "Tags" },
    { key: 'createdAt', value: 'createdAt', order: 1, text: "CreatedAt" },
];

let InitiativeArr = [
    { key: 'subCategory', value: 'subCategory', order: -1, text: "Sub Category" },
    { key: 'status', value: 'status', order: -1, text: "Status" },
    { key: 'priority', value: 'priority', order: 1, text: "Priority" },
    // { key: 'playbook', value: 'playbook', order: -1, text: "Playbook" },
];

class GroupIcon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: null,
            order: null,
            value: null,
            open: false
        }
    }
    componentDidMount(){
        if (this.props.sortingFlag) {
            const selectedFilter = PlaybookArr.find(item => item.key === this.props.sortingFlag.key) || InitiativeArr.find(item => item.key === this.props.sortingFlag.key);
            this.setState({ 
                label: selectedFilter ? selectedFilter.text : this.props.sortingFlag.text, 
                value: this.props.sortingFlag.key 
            });
        }
        this.props.sortingFlag && this.props.sortingFlag.text && this.setState({label:this.props.sortingFlag.text})
    }
    componentDidUpdate(prevProps) {
        if(this.props.PracticeLibrarys !== prevProps.PracticeLibrarys) {
            //this.reset()
            this.props.sortingFlag && this.props.sortingFlag.text && this.setState({label:this.props.sortingFlag.text,value:this.props.sortingFlag.text})
        }
        //change for KLM-9311
        if(this.props.InitiativeLibrary !== prevProps.InitiativeLibrary) {          
            this.props.sortingFlag && this.props.sortingFlag.text && this.setState({label:this.props.sortingFlag.text, value:this.props.sortingFlag.text})
        }
      }

    handleChangeFilter = (e, { value, order, label }) => {
        this.setState({ value });
        this.setState({ order: order, label: label });
        setTimeout(() => {
            this.props.handleSort(this.state)
        }, 100);
    }

    toggleSort = () => {
        if (this.state.order === -1) {
            this.setState({ order: 1 })
        } else {
            this.setState({ order: -1 })
        }
        setTimeout(() => {
            this.props.handleSort(this.state)
        }, 100);

    }
    onOpen = () => {
        this.setState({ open: !this.state.open })
    }
    onClose = () => {
        this.setState({ open: false })
    }

    reset = () => {
        this.setState({
            value: 'reset',
            open: false,
            order: null,
            label: null
        });
        setTimeout(() => {
            this.props.handleSort(this.state)
        }, 100);
    }

    render() {


        let filterOption = []
        if (this.props.page === "Playbook") {
            filterOption = PlaybookArr.map(f => {
                if (f.key === 'status' && (this.props.routeParams.status === "playbookLibrary" || this.props.routeParams.status === "knowledgeBank" || this.props.routeParams.status === "publicKnowledgeBank")) {
                    f.disabled = false
                } else if (f.key === 'status' && typeof (this.props.routeParams.status) === "string") {
                    f.disabled = true
                } else {
                    f.disabled = false
                }
                return f
            })
        } else if (this.props.page === "Initiative") {
            filterOption = InitiativeArr.map(f => {
                if (f.key === 'status' && typeof (this.props.routeParams.status) === "string") {
                    f.disabled = true
                } else {
                    f.disabled = false
                }
                return f
            })
        }


        return (
            <Popup
                trigger={
                    <Button
                        onClick={this.onOpen}
                        className="float-right pad_5"
                        size="mini"
                    >
                        <span style={{
                            minWidth: "110px",
                            display: "inline-block",
                            textAlign: "left"
                        }}>
                            {this.state.label || this.props.sortingFlag ? "Group By : " : "Groups "}
                            <b>{this.state.label ? this.state.label : this.props.sortingFlag ?
                                capitalizeWord(this.props.sortingFlag.text) : null
                            }</b>
                        </span>

                        <Icon name='angle down' />
                    </Button>

                }
                on='click'
                position="bottom right"
                open={this.state.open}
                onClose={this.onClose}
                onOpen={this.onOpen}
                hideOnScroll
                className="groupIconList"
            >
                <Popup.Content style={{ width: "140px" }}>
                    <Form>

                        {filterOption && filterOption.map((f, i) => {

                            let removeItemFromList = this.props.routeParams &&
                                this.props.routeParams.status &&
                                this.props.routeParams.status === 'In Design' && f.value === 'status' ? false :
                                this.props.routeParams.status === 'underReview' && f.value === 'status' ? false :
                                    this.props.routeParams.status === 'inReview' && f.value === 'status' ? false :
                                        this.props.routeParams.status === 'forReview' && f.value === 'status' ? false :
                                            this.props.routeParams.status === 'Approved' && f.value === 'status' ? false :
                                                this.props.routeParams.status === 'Published' && f.value === 'status' ? false :
                                                    this.props.routeParams.status === 'Inactive' && f.value === 'status' ? false :
                                                    this.props.routeParams.status === 'knowledgeBank' && f.value === 'scope' ? false :
                                                        this.props.routeParams.status === 'publicKnowledgeBank' && f.value === 'scope' ? false : true

                            return removeItemFromList && <React.Fragment key={i}>
                                <Form.Field
                                    style={{
                                        width: "calc(100% - 40px)",
                                        float: "left"
                                    }}>
                                    <Radio
                                        label={f.text}
                                        name='filterGroup'
                                        value={f.value}
                                        checked={this.state.value === f.value || this.props.sortingFlag && this.props.sortingFlag.key === f.value}
                                        onChange={this.handleChangeFilter}
                                        order={f.order}
                                        disabled={f.disabled}
                                    />
                                </Form.Field>

                            </React.Fragment>
                        })}
                        <Form.Field>
                            <span
                                className="resetIcon"
                                onClick={this.reset}>
                                Reset
                            </span>
                        </Form.Field>
                    </Form>
                </Popup.Content>
            </Popup>
        )
    }
}

export default GroupIcon